<template>
  <div>
    <q-intersection transition="slide-down" v-show="filter">
      <q-form @submit.prevent="onFilterReports" @reset="clearFilter">
        <q-card flat v-if="filter" bordered class="q-mb-sm">
          <q-toolbar>
            <q-toolbar-title> {{ $t('filter_by') }}</q-toolbar-title>
            <q-btn flat round dense icon="mdi-close" @click="filter = false" />
          </q-toolbar>
          <q-card-section class="q-pt-none row q-col-gutter-md">
            <div class="col-4">
              <q-input outlined v-model="params.orderId" type="text" :label="$t('request_number')" />
            </div>
            <div class="col-4">
              <q-input outlined v-model="params.actionId" type="text" label="ID da conversão" />
            </div>

            <div class="col-4">
              <q-select
                v-model="params.campaignId"
                use-input
                input-debounce="200"
                @filter="filterComboCampaigns"
                :options="campaignsFiltered"
                :label="$t('campaign')"
                option-label="name"
                option-value="id"
                outlined
              />
            </div>
            <div class="col-6">
              <date-input
                buttons
                outlined
                :label="$t('conversion_date')"
                :v-model="params.date"
                @update="(value) => (params.date = value)"
                clearable
                range
                today-btn
              />
            </div>
            <div class="col-6">
              <div class="row q-col-gutter-sm">
                <div class="col">
                  <q-select
                    v-model="params.status"
                    :options="[
                      {
                        label: $t('approved'),
                        value: 2
                      },
                      {
                        label: $t('pending'),
                        value: 1
                      },
                      {
                        label: $t('refused'),
                        value: 0
                      }
                    ]"
                    :label="$t('conversion_status')"
                    outlined
                  />
                </div>
              </div>
            </div>
            <div class="col-4">
              <q-input v-model="params.siteId" use-input input-debounce="200" label="Canal ID" outlined type="number" />
            </div>

            <div class="col-4">
              <q-input v-model="params.siteName" use-input label="Nome do canal" outlined />
            </div>

            <div class="col-4">
              <q-input v-model="params.affiliateName" use-input :label="$t('affiliate_name')" outlined />
            </div>

            <div class="col-12 text-right">
              <q-btn color="primary" :label="$t('clear')" no-caps outline class="q-px-md q-mx-md" type="reset" />
              <q-btn color="positive" :label="$t('search')" no-caps unelevated class="q-px-md" type="submit" />
            </div>
          </q-card-section>
        </q-card>
      </q-form>
    </q-intersection>
  </div>
</template>

<script>
import ReportMixin from '../../../mixins/ReportMixin';
import DateInput from '../../../widgets/inputsGlobal/DateInput';

export default {
  name: 'AdvertiserHeaderConversionReports',
  components: { DateInput },
  mixins: [ReportMixin],
  data() {
    return {
      filter: true,
      params: {
        orderId: null,
        actionId: null,
        siteId: null,
        campaignId: null,
        date: null,
        status: null,
        siteName: null,
        affiliateName: null
      },
      campaignsList: [],
      campaignsFiltered: []
    };
  },

  methods: {
    async getCampaigns() {
      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          '/redirect?app=advertiser&path=/api/get/campaign/advertiser/' + this.user.advertiser_id
        );
        if (status === 200) {
          this.campaignsList = data;
          this.campaignsFiltered = data;
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    filterComboCampaigns(val, update) {
      update(() => {
        const needle = val.toLocaleLowerCase();
        if (!needle) this.campaignsFiltered = this.campaignsList;
        this.campaignsFiltered = this.campaignsList.filter((v) => v.name.toLocaleLowerCase().indexOf(needle) > -1);
      });
    },

    clearFilter() {
      for (let i in this.params) this.params[i] = Array.isArray(this.params[i]) ? [] : null;

      /*  this.ActionSetFilterReports(
          [`id_affiliate=${this.getProfiles.affiliate_id}`].join("%26")
        ); */
      this.ActionSetReports([]);
      this.ActionSetFilterReports();

      /* this.getConversionReportAffiliate(
        [`id_affiliate=${this.getProfiles.affiliate_id}`].join("%26")
      ); */
    },

    onFilterReports() {
      let filterSelect = [`id_advertiser=${this.user.advertiser_id}`];
      /* if (this.params.siteId)
        filterSelect.push(`site_id=${this.params.siteId}`); */
      if (this.params.orderId) filterSelect.push(`order_id=${this.params.orderId}`);
      if (this.params.actionId) filterSelect.push(`transaction_id=${this.params.actionId}`);
      if (this.params.campaignId) filterSelect.push(`campaign_id=${this.params.campaignId.id}`);

      if (this.params.siteId) filterSelect.push(`one_site=${this.params.siteId}`);

      if (this.params.siteName) filterSelect.push(`site_name=${this.params.siteName}`);

      if (this.params.affiliateName) filterSelect.push(`affiliate_name=${this.params.affiliateName}`);

      if (this.params.date) {
        let [from, , to] = this.params.date.split(' ');
        from = this.formatToEn(from);
        to = this.formatToEn(to);
        filterSelect.push(`start_date=${from}`);
        filterSelect.push(`end_date=${to}`);
      }

      if (this.params.status) filterSelect.push(`validation_status=${this.params.status.value}`);

      this.ActionSetFilterReports(filterSelect.join('%26'));
      this.getConversionReportAdvertiser();
    }
  },

  created() {
    this.getCampaigns();
  }
};
</script>
